/* ════════════════════════════════════════════════════════════
   triQUIP "REQUEST WE FETCH" WIDGET
   Lets a customer ask for a product that's out of stock, or a
   brand/product you don't currently carry, and have you try to
   source it for them.

   HOW TO USE:
   1. Set WHATSAPP_NUMBER and CONTACT_EMAIL below.
   2. Add this as a new asset (e.g. request-product.js) in your
      theme's Assets folder, and load it with one more script tag
      in your page template, same way as the other JS assets:
        {{ 'request-product.js' | asset_url | script_tag }}
   3. That's it — no HTML changes needed. It injects its own
      floating button, modal, and styling when the page loads.

   HOW SUBMISSIONS ARRIVE:
   - The form posts to Shopify's built-in /contact endpoint, which
     is native to every Shopify store — no app, no API token, no
     backend needed. It lands as a normal email to whatever address
     is set under Settings → Notifications → Customer contact form
     in your Shopify admin (check that's the address you want).
   - The WhatsApp button is a straight fallback for anyone who'd
     rather just message you directly — prefilled with their
     request so they don't have to type it all out.
════════════════════════════════════════════════════════════ */
(function(){
  const WHATSAPP_NUMBER = '917977519164'; // your WhatsApp Business number, country code + number, no + or spaces
  const CONTACT_EMAIL = 'info@triQUIPsports.com'; // used as the fallback "from" address when a customer gives a phone number instead of an email

  const css = `
  .rwf-float{position:fixed;bottom:24px;left:24px;z-index:199;background:#fff;color:#14171A;
    font-family:'Poppins',sans-serif;font-size:12.5px;font-weight:700;letter-spacing:.02em;
    border:1.5px solid #E4E5E8;border-radius:30px;padding:12px 18px;cursor:pointer;
    box-shadow:0 6px 20px rgba(0,0,0,.08);display:flex;align-items:center;gap:8px;transition:all .2s}
  .rwf-float:hover{border-color:#FF5000;color:#FF5000;transform:translateY(-2px)}
  .rwf-overlay{position:fixed;inset:0;background:rgba(20,23,26,.5);z-index:400;display:none;
    align-items:center;justify-content:center;padding:20px}
  .rwf-overlay.show{display:flex}
  .rwf-modal{background:#fff;border-radius:16px;width:420px;max-width:100%;padding:26px;
    font-family:'Poppins',sans-serif;color:#14171A;max-height:88vh;overflow-y:auto}
  .rwf-modal h3{margin:0 0 4px;font-size:18px;font-weight:800}
  .rwf-modal p.sub{margin:0 0 18px;font-size:12.5px;color:#5B6167;line-height:1.5}
  .rwf-field{margin-bottom:12px}
  .rwf-field label{display:block;font-size:10.5px;font-weight:700;text-transform:uppercase;
    letter-spacing:.04em;color:#5B6167;margin-bottom:4px}
  .rwf-field input,.rwf-field textarea{width:100%;font-family:'Poppins',sans-serif;font-size:13px;
    border:1px solid #CDD1C9;border-radius:8px;padding:9px 10px;box-sizing:border-box}
  .rwf-field textarea{min-height:70px;resize:vertical}
  .rwf-actions{display:flex;gap:8px;margin-top:16px}
  .rwf-btn{flex:1;font-family:'Poppins',sans-serif;font-size:12.5px;font-weight:700;
    border:none;border-radius:8px;padding:11px;cursor:pointer;text-align:center;text-decoration:none;
    display:inline-flex;align-items:center;justify-content:center;gap:6px}
  .rwf-btn-primary{background:#FF5000;color:#fff}
  .rwf-btn-primary:hover{background:#CC4000}
  .rwf-btn-wa{background:#25D366;color:#fff}
  .rwf-btn-wa:hover{opacity:.9}
  .rwf-close{position:absolute;top:14px;right:16px;background:none;border:none;font-size:20px;
    cursor:pointer;color:#9A9E99}
  .rwf-modal{position:relative}
  .rwf-status{font-size:12px;margin-top:10px;text-align:center}
  .rwf-status.ok{color:#0F7A42}
  .rwf-status.err{color:#B23A2E}
  `;
  const styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  const floatBtn = document.createElement('button');
  floatBtn.className = 'rwf-float';
  floatBtn.innerHTML = `Can't find it? Request it`;
  document.body.appendChild(floatBtn);

  const overlay = document.createElement('div');
  overlay.className = 'rwf-overlay';
  overlay.innerHTML = `
    <div class="rwf-modal">
      <button class="rwf-close" id="rwfClose">&times;</button>
      <h3>Request a product</h3>
      <p class="sub">Out of stock, or a brand we don't carry yet? Tell us what you're after and we'll try to source it for you.</p>
      <div class="rwf-field">
        <label>What are you looking for</label>
        <input type="text" id="rwfProduct" placeholder="e.g. Hoka Speedgoat 6, size UK 9">
      </div>
      <div class="rwf-field">
        <label>Any link or reference (optional)</label>
        <input type="text" id="rwfLink" placeholder="Paste a link if you've seen it elsewhere">
      </div>
      <div class="rwf-field">
        <label>Your name</label>
        <input type="text" id="rwfName">
      </div>
      <div class="rwf-field">
        <label>Phone or email, so we can reach you</label>
        <input type="text" id="rwfContact" placeholder="WhatsApp number or email">
      </div>
      <div class="rwf-field">
        <label>Anything else (optional)</label>
        <textarea id="rwfNotes" placeholder="Budget, colour, size, urgency — whatever helps us find it faster"></textarea>
      </div>
      <div class="rwf-actions">
        <button class="rwf-btn rwf-btn-primary" id="rwfSubmit">Send request</button>
        <a class="rwf-btn rwf-btn-wa" id="rwfWhatsapp" href="#" target="_blank" rel="noopener">WhatsApp instead</a>
      </div>
      <div class="rwf-status" id="rwfStatus"></div>
      <p class="sub" style="margin:14px 0 0;text-align:center">Or email us directly at <a href="mailto:${CONTACT_EMAIL}" style="color:#FF5000">${CONTACT_EMAIL}</a></p>
    </div>
  `;
  document.body.appendChild(overlay);

  function buildMessage(){
    const product = document.getElementById('rwfProduct').value.trim();
    const link = document.getElementById('rwfLink').value.trim();
    const notes = document.getElementById('rwfNotes').value.trim();
    let msg = `Product request: ${product || '(not specified)'}`;
    if(link) msg += `\nReference link: ${link}`;
    if(notes) msg += `\nNotes: ${notes}`;
    return msg;
  }

  function updateWhatsappLink(){
    const name = document.getElementById('rwfName').value.trim();
    const msg = buildMessage();
    const text = encodeURIComponent(`Hi triQUIP, I'd like to request a product.\n\n${msg}${name?`\n\n— ${name}`:''}`);
    document.getElementById('rwfWhatsapp').href = `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
  }
  overlay.addEventListener('input', updateWhatsappLink);

  floatBtn.addEventListener('click', ()=>{
    overlay.classList.add('show');
    document.getElementById('rwfStatus').textContent = '';
    updateWhatsappLink();
  });
  document.getElementById('rwfClose').addEventListener('click', ()=> overlay.classList.remove('show'));
  overlay.addEventListener('click', e=>{ if(e.target===overlay) overlay.classList.remove('show'); });

  document.getElementById('rwfSubmit').addEventListener('click', async ()=>{
    const product = document.getElementById('rwfProduct').value.trim();
    const name = document.getElementById('rwfName').value.trim();
    const contact = document.getElementById('rwfContact').value.trim();
    const statusEl = document.getElementById('rwfStatus');

    if(!product || !name || !contact){
      statusEl.textContent = 'Please fill in what you need, your name, and how to reach you.';
      statusEl.className = 'rwf-status err';
      return;
    }

    const isEmail = /\S+@\S+\.\S+/.test(contact);
    const body = `PRODUCT REQUEST\n\n${buildMessage()}\n\nContact: ${contact}`;

    const fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[name]', name);
    fd.append('contact[email]', isEmail ? contact : CONTACT_EMAIL);
    fd.append('contact[phone]', isEmail ? '' : contact);
    fd.append('contact[body]', body);

    statusEl.textContent = 'Sending…';
    statusEl.className = 'rwf-status';

    try{
      const res = await fetch('/contact', { method: 'POST', body: fd });
      if(res.ok){
        statusEl.textContent = "Got it — we'll be in touch once we track it down.";
        statusEl.className = 'rwf-status ok';
        ['rwfProduct','rwfLink','rwfName','rwfContact','rwfNotes'].forEach(id=>document.getElementById(id).value='');
      } else {
        throw new Error('Non-OK response');
      }
    } catch(err){
      console.error('Product request submission failed:', err);
      statusEl.innerHTML = `Couldn't send that — please try the WhatsApp option instead.`;
      statusEl.className = 'rwf-status err';
    }
  });
})();